/**
 * Platform AI controls (TMMPDM-0088, tmm-api 0153 `/v1/admin/ai-controls`): the domain helper's
 * daily caps, platform-paid AI. Live, effective-dated settings through the shared component.
 */
import { useCallback } from 'react';
import { adminApi } from '@/api/tmm/admin';
import {
  EffectiveDatedSettings,
  type SettingField,
} from '@/components/settings/EffectiveDatedSettings';
import { useCopy } from '@/hooks/useCopy';

export function PlatformAiControls() {
  const { t } = useCopy();
  const load = useCallback(() => adminApi.getPlatformAiControls(), []);
  const help = t(
    'platformAiControls.help',
    "The domain helper's AI is paid by the platform. These caps limit it.",
  );
  const fields: SettingField[] = [
    {
      key: 'domainSetupResellerDaily',
      label: t('platformAiControls.resellerDaily', 'Domain-setup AI calls per reseller per day'),
      help,
      kind: 'integer',
      min: 1,
    },
    {
      key: 'domainSetupPlatformDaily',
      label: t(
        'platformAiControls.platformDaily',
        'Domain-setup AI calls across the platform per day',
      ),
      help,
      kind: 'integer',
      min: 1,
    },
  ];
  return (
    <EffectiveDatedSettings
      title={t('platformAiControls.title', 'Platform AI controls')}
      help={help}
      fields={fields}
      load={load}
      schedule={(body) => adminApi.schedulePlatformAiControls(body)}
      withdraw={(rowId, note) => adminApi.withdrawPlatformAiControls(rowId, note)}
    />
  );
}
